module.exports = __webpack_public_path__ + "static/media/AnnualLeave.73137696.svg";